<template>
  <div class="row">
    <div class="col-6 d-flex align-items-center">
      <h6 class="mb-0">Master Dealer</h6>
    </div>
    <div class="col-6 text-end">
      <button class="btn bg-gradient-dark mb-0" @click="openSidebar">
        <i class="fas fa-plus me-1"></i> Add Master Dealer
      </button>
    </div>

    <retailer-detail />
    <retailer-top-up />
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import retailerDetail from "./sidebar/retailerDetail.vue";
import retailerTopUp from "./sidebar/retailerTopUp.vue";

export default {
  components: {
    retailerDetail,
    retailerTopUp,
  },
  methods: {
    ...mapMutations({
      toggleShowRetailerSidebar:
        "retailerController/TOGGLE_ShowRetailerSidebar",
      ResetRetailer: "retailerController/SELECT_Retailer",
    }),
    openSidebar() {
      this.toggleShowRetailerSidebar(true);
      this.ResetRetailer({});
      console.log(this.selectedRetailer);
    },
  },
};
</script>

<style></style>
